<template>
  <v-row>
    <v-col cols="6">
      <TabsComponent :slots="slots">
        <template slot="interest">
          <FieldListComponent title="Interesse" v-model="fieldListModel"/>
        </template>
        <template slot="tab1">
          <v-card-text>
            Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et
            dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet
            clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet,
            consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat,
            sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea
            takimata sanctus est Lorem ipsum dolor sit amet.
          </v-card-text>
        </template>
      </TabsComponent>
    </v-col>
    <v-col cols="6">
      <card-component>
        <v-card-text>
          Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et
          dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet
          clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet,
          consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat,
          sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea
          takimata sanctus est Lorem ipsum dolor sit amet.
        </v-card-text>
      </card-component>
    </v-col>
  </v-row>
</template>

<script>
import {reactive} from '@vue/composition-api'
import TabsComponent from "@/components/tabs/TabsComponent";
import FieldListComponent from "@/components/form/FieldListComponent";
import CardComponent from "../components/form/CardComponent";

export default {
  name: "TabsView",
  components: {CardComponent, FieldListComponent, TabsComponent},
  setup() {
    let slots = [
      {
        name: 'interest',
        title: 'Interesse'
      }
    ]

    for (let i = 1; i < 20; i++) {
      slots.push({
        name: 'tab' + i,
        title: 'Tab ' + i
      })
    }

    const fieldListModel = reactive([
      {inputValue: 'Fancy CRM', type: 'TextFieldCustom', fieldName: 'Produkt', edit: false},
      {inputValue: '100-200', type: 'TextFieldCustom', fieldName: '#Lizenzen', edit: false},
      {inputValue: 'ab Q2/2021', type: 'TextFieldCustom', fieldName: 'Starttermin', edit: false},
      {inputValue: 'Cebit 2019', type: 'TextFieldCustom', fieldName: 'Kampagne', edit: false},
    ])
    return {slots, fieldListModel}
  }
}
</script>

<style scoped>

</style>
